import kaedco from "../../../assets/images/Kaduna.png";
import kedco from "../../../assets/images/Kano.png";
import ikedc from "../../../assets/icons/ikedc.svg";
import eedc from "../../../assets/icons/eedc.svg";
import phed from "../../../assets/icons/phdc.svg";
import aedc from "../../../assets/icons/aedc.svg";
import ekedc from "../../../assets/icons/ekedc.svg";
import ibedc from "../../../assets/images/ibedc.png";
import jed from "../../../assets/images/jed.jpg";
import aba from "../../../assets/images/ABA.jpg";
import yedc from "../../../assets/images/YEDC.jpg";
import bedc from "../../../assets/images/BEDC.png";

const generateBankImageUrl = (provider) => {
  switch (provider) {
    case "ikedc":
      return ikedc;
    case "ekedc":
      return ekedc;
    case "phed":
      return phed;
    case "kaedco":
      return kaedco;
    case "kedco":
      return kedco;
    case "eedc":
      return eedc;
    case "aedc":
      return aedc;
    case "ibedc":
      return ibedc;
    case "jed":
      return jed;
    case "aba":
      return aba;
    case "ibedc":
      return ibedc;
    case "bedc":
      return bedc;
    case "yedc":
      return yedc;
    default:
      return ikedc;
  }
};

export default generateBankImageUrl;
